import Nbt from "./mission/nbt/Nbt";
import Avatye from "./mission/avatye/Avatye";
import AccessDeniedPage from "./mission/common/AccessDeniedPage";
import {StrictRouteContext} from "./RouteContext";
import ToktokquizC from "./mission/toktokquiz-c/Toktokquiz-c";
import ToktokquizB from "./mission/toktokquiz-b/Toktokquiz-b";
import {useEffect} from "react";
import ToktokquizVer2 from "./mission/toktokquiz-ver2/Toktokquiz-ver2";
import Cashpick2 from "./mission/cashpick-2/Cashpick2";
import Cashpick1 from "./mission/cashpick-1/Cashpick1";

export const getCurrentSubDomain= () => {
    return window.location.hostname.split(".")[0]
}

export const isLocal= () => {
    return window.location.hostname.includes('localhost')
}

export default function HomePage(props: StrictRouteContext) {

    const currentSubDomain = getCurrentSubDomain();

    useEffect(()=>{
        document.title = currentSubDomain;
    },[])

    function Page() {

        if(isLocal())
        return <Nbt />

        if(currentSubDomain === "nbt")
            return (
                <Nbt />
            )

        if(currentSubDomain === "avatye")
            return (
                <Avatye />
            )

        if(currentSubDomain==="toktokquiz-c")
            return (
                <ToktokquizC />
            )

        if(currentSubDomain==="toktokquiz")
            return (
                <ToktokquizB />
            )

        if(currentSubDomain==="dev")
            return (
                <Nbt />
            )

        if(currentSubDomain==="toktokquiz-dev")
            return (
                <ToktokquizB />
            )

        if(currentSubDomain==="missionbox")
            return (
                <ToktokquizVer2 />
            )

        if(currentSubDomain==="cashpick-1")
            return (
                <Cashpick1 />
            )

        if(currentSubDomain==="cashpick-2")
            return (
                <Cashpick2 />
            )

        return <AccessDeniedPage />

    }

    return <Page />
}